module.exports = __webpack_public_path__ + "img/解决方案.67eabf31.jpg";